import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Btn } from "@/components/common";
import { Send } from "lucide-react";

export default function AfterPayDialog({ s, galleries, onClose, onSend }) {
  const [sel, setSel] = useState([]);
  const toggle = (id) => setSel((l) => (l.includes(id) ? l.filter((x) => x !== id) : [...l, id]));
  const go = async () => {
    try {
      await api.put(`/photo-stays/${s.booking_id}/galleries`, { gallery_ids: sel });
      onSend({ ...s, gallery_ids: sel });
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="afterpay-dialog">
        <DialogHeader><DialogTitle>Pagato · {s.guest || s.room}</DialogTitle></DialogHeader>
        <div className="text-sm text-slate-600">Scegli le gallerie che questa camera può scaricare, poi invia il link su WhatsApp.</div>
        <div className="max-h-64 overflow-y-auto border border-slate-200 rounded-md p-2">
          {galleries.length === 0 && <div className="text-sm text-slate-400">Nessuna galleria caricata</div>}
          {galleries.map((g) => (
            <label key={g.id} className="flex items-center gap-2 text-sm py-1">
              <input type="checkbox" checked={sel.includes(g.id)} onChange={() => toggle(g.id)} data-testid={`afterpay-gal-${g.id}`} />
              <span className="truncate">{g.title}</span>
              <span className="ml-auto text-[10px] text-slate-400">{g.created_at.slice(0, 10).split("-").reverse().join("/")}</span>
            </label>
          ))}
        </div>
        <div className="flex justify-between gap-2 mt-2">
          <button onClick={onClose} className="text-sm text-slate-500 font-semibold" data-testid="afterpay-later">Più tardi</button>
          <Btn onClick={go} disabled={!sel.length} data-testid="afterpay-send"><Send size={14} /> Salva e apri WhatsApp</Btn>
        </div>
      </DialogContent>
    </Dialog>
  );
}
